/**
 * Preferred tour-manager paths for show-scoped travel (sanitized REST).
 * Legacy `user/tm/hotels`, `user/tm/flights`, etc. remain on the backend.
 */
export const TOURING_API = {
  flights: 'user/tm/touring/flights',
  lodging: 'user/tm/touring/lodging',
  groundTransport: 'user/tm/touring/ground-transport',
  crew: 'user/tm/touring/crew',
} as const

export const LODGING_TYPE_OPTIONS = [
  { value: 'hotel', label: 'Hotel' },
  { value: 'house', label: 'House' },
  { value: 'apartment', label: 'Apartment' },
  { value: 'bnb', label: 'BNB' },
  { value: 'villa', label: 'Villa' },
  { value: 'other', label: 'Other' },
] as const

export type LodgingTypeId = (typeof LODGING_TYPE_OPTIONS)[number]['value']

export function lodgingTypeLabel(id: string | undefined): string {
  if (!id) return 'Lodging'
  const row = LODGING_TYPE_OPTIONS.find((o) => o.value === id)
  return row?.label || id
}
